import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  fill: "none",
  height: "12",
  viewBox: "0 0 14 12",
  width: "14",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "clip-rule": "evenodd",
  d: "M2.19997 0.399994C1.31632 0.399994 0.599976 1.11634 0.599976 1.99999V9.99999C0.599976 10.8837 1.31632 11.6 2.19997 11.6H11.7999C12.6836 11.6 13.3999 10.8837 13.3999 9.99999V1.99999C13.3999 1.11634 12.6836 0.399994 11.7999 0.399994H2.19997ZM11.7999 9.99999H2.19997L5.39996 3.59999L7.79996 8.39999L9.39996 5.19999L11.7999 9.99999Z",
  fill: "currentColor",
  "fill-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}